/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ConsumableOrder from './consumable-order';
import ConsumableOrderDetail from './consumable-order-detail';
import ConsumableOrderUpdate from './consumable-order-update';
import ConsumableOrderDeleteDialog from './consumable-order-delete-dialog';

const ConsumableOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ConsumableOrder />} />
    <Route path="new" element={<ConsumableOrderUpdate />} />
    <Route path=":id">
      <Route index element={<ConsumableOrderDetail />} />
      <Route path="edit" element={<ConsumableOrderUpdate />} />
      <Route path="delete" element={<ConsumableOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ConsumableOrderRoutes;
